import React from "react";
import { useTranslation } from "react-i18next";
import "../App.css"; // Assuming you have some global styles
const products = [
  {
    image: "488642912_1135361201936599_4107941449625015817_n.jpg",
  },
  {
    image: "487213944_1130378092434910_6530384502859974709_n.jpg",
  },
  {
   
    image: "487479393_1129314419207944_4770071709769154605_n.jpg",
  },
  {

    image: "487311465_1129300272542692_3203436075102045715_n.jpg",
  },
];

const ProductGallery = () => {
        const { t } = useTranslation();
  return (
    <section className="gallery-section" id="gallery">
      <h2 className="gallery-title">{t("products")}</h2>
      <div className="gallery-grid">
        {products.map((product) => (
          <div className="gallery-item" key={product.id}>
            <img src={product.image} alt={product.name} />
            <div className="gallery-name">{product.name}</div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default ProductGallery;
